import { make } from 'vuex-pathify'
import HELP_ARTICLES from '@/data/helpArticles'

const normalize = value => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()

const searchableText = article => [
  article.title,
  article.subtitle,
  ...(article.keywords || []),
  ...(article.sections || []).reduce((values, section) => values.concat([
    section.title,
    section.text,
    ...(section.steps || []),
    ...(section.bullets || []),
  ]), []),
  ...(article.problems || []).reduce((values, problem) => values.concat([
    problem.question,
    problem.solution,
  ]), []),
].map(normalize).join(' ')

const state = {
  articles: HELP_ARTICLES,
  loading: false,
}

const mutations = make.mutations(state)

const actions = {
  get: ({ state }, search = '') => {
    const term = normalize(search).trim()

    state.articles = term
      ? HELP_ARTICLES.filter(article => searchableText(article).includes(term))
      : HELP_ARTICLES

    return state.articles
  },
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
